import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useWebsiteSettings } from "../contexts/WebsiteSettingsContext";

export default function Navbar() {
  const location = useLocation();
  const { settings, isLoading } = useWebsiteSettings();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };
  const [hideNavbar, setHideNavbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setHideNavbar(window.scrollY > 100); // 100px scroll par hide
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (isLoading) return null;

  return (
    <>
      <nav
        className={`py-1 px-6 w-full z-[9999]
          ${location.pathname === "/" ? "fixed top-0 left-0" : "relative"} 
          ${hideNavbar && location.pathname === "/" ? "hidden" : ""} 
        `}
        style={{
          backgroundColor:
            location.pathname === "/" ? "rgba(0, 0, 0, 0.2)" : "#ffffff",
        }}
      >

        <div className="flex justify-between items-center px-6">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src={settings?.logo || "/images/home/logo.png"}
              alt="Logo"
              className="h-14 md:h-20 w-full object-contain"
            />
          </Link>

          {/* Desktop Navigation Menu */}
          <ul
            className={`hidden md:flex space-x-6 items-center font-semibold text-2xl 
              ${location.pathname === "/" ? "text-white" : "text-black"}
            `}
          >
            <li>
              <Link
                to="/"
                className={`hover:text-red-600 ${isActive("/") ? "text-red-600 border-b" : ""
                  }`}
              >
                Home
              </Link>
            </li>

            <li>
              <Link
                to="/services"
                className={`hover:text-red-600 ${isActive("/services") ? "text-red-600 border-b" : ""
                  }`}
              >
                Services
              </Link>
            </li>

            <li>
              <Link
                to="/projects"
                className={`hover:text-red-600 ${isActive("/projects") ? "text-red-600 border-b" : ""
                  }`}
              >
                Projects
              </Link>
            </li>

            <li>
              <Link
                to="/about"
                className={`hover:text-red-600 ${isActive("/about") ? "text-red-600 border-b" : ""
                  }`}
              >
                About
              </Link>
            </li>

            <li>
              <Link
                to="/contact"
                className={`hover:text-red-600 ${isActive("/contact") ? "text-red-600 border-b" : ""
                  }`}
              >
                Contact
              </Link>
            </li>
          </ul>

          {/* Mobile Menu Button */}
          <button
            className={`md:hidden text-4xl font-bold ${isActive("/") ? "text-white" : "text-black"
              }`}
            onClick={() => setIsMenuOpen(true)}
            aria-label="Open menu"
          >
            <i className="bi bi-list"></i>
          </button>
        </div>
      </nav>

      {/* Mobile Sidebar Menu */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 z-[10098] bg-black/40 md:hidden"
          onClick={() => setIsMenuOpen(false)}
        >
          <div
            className="absolute left-0 top-0 h-full w-72 bg-white shadow-lg p-6 flex flex-col space-y-6"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-4">
              <span className="font-bold text-xl">Menu</span>
              <button
                onClick={() => setIsMenuOpen(false)}
                aria-label="Close menu"
                className="text-2xl font-bold"
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>

            <Link
              to="/"
              onClick={() => setIsMenuOpen(false)}
              className={`text-xl font-semibold ${isActive("/") ? "text-red-600" : "text-gray-900"
                }`}
            >
              Home
            </Link>

            <Link
              to="/services"
              onClick={() => setIsMenuOpen(false)}
              className={`text-xl font-semibold ${isActive("/services") ? "text-red-600" : "text-gray-900"
                }`}
            >
              Services
            </Link>

            <Link
              to="/projects"
              onClick={() => setIsMenuOpen(false)}
              className={`text-xl font-semibold ${isActive("/projects") ? "text-red-600" : "text-gray-900"
                }`}
            >
              Projects
            </Link>

            <Link
              to="/about"
              onClick={() => setIsMenuOpen(false)}
              className={`text-xl font-semibold ${isActive("/about") ? "text-red-600" : "text-gray-900"
                }`}
            >
              About
            </Link>

            <Link
              to="/contact"
              onClick={() => setIsMenuOpen(false)}
              className={`text-xl font-semibold ${isActive("/contact") ? "text-red-600" : "text-gray-900"
                }`}
            >
              Contact
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
